import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: HeaderSliceState = {
  headerTabs: undefined,
};

export interface HeaderSliceState {
  headerTabs: HeaderTabs[] | undefined;
}

export interface HeaderTabs {
  title: string;
  path: string;
}

const HeaderSlice = createSlice({
  name: "header",
  initialState: initialState,
  reducers: {
    setHeaderTabs: (state: HeaderSliceState, action: PayloadAction<HeaderTabs[] | undefined>) => {
      state.headerTabs = action.payload;
    },
  },
});

export const { setHeaderTabs } = HeaderSlice.actions;

export default HeaderSlice;
